import { CmpsPopulationCompareGroupData } from '@cmps/ng-kit';

import { HeaderRowData } from '../card--my-coaching-card/models/header-row-data.model';

import { PerformanceCard } from './models/performance-card.model';
import { PerformancePillar } from './models/performance-pillar.model';
import { PeriodCompareDialogData } from './models/period-compare-dialog.model';

export interface PerformanceCardState {
    pending: {
        reload?: boolean;
        hasData?: boolean;
    };
    performanceCard?: PerformanceCard;
    totalPerformancePillar?: PerformancePillar;
    pillarsData?: PerformancePillar[];
    periodCompareDialogData?: PeriodCompareDialogData;
    headerData?: HeaderRowData;
    populationCompareDialogData?: CmpsPopulationCompareGroupData[];
}

export const defaultState = (): PerformanceCardState => ({
    pending: {},
});
